module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_06_15_us_alligator-attacks-child-disney-florida_index.html_plot.a21d4caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_06_15_us_alligator-attacks-child-disney-florida_index.html_plot.png
// module id = 371
// module chunks = 0